/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { connect } from "react-redux";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Tooltip,
  IconButton,
} from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";

import { getKeluarga } from "../../../../../store/actions";
import { capitalize } from "../../../../../shared/utility";

const useStyles = makeStyles({
  table: {
    minWidth: 700,
  },
  iconAction: {
    cursor: "pointer",
  },
});

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#285D5F",
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

const TableKeluarga = ({
  detailEmployee,
  getKeluarga,
  setDialog,
  auth,
  hcis,
}) => {
  const classes = useStyles();
  const params = useParams();

  useEffect(() => {
    if (
      (auth.user.role_name === "hcis" || auth.user.role_name === "manager") &&
      auth.user.id !== parseInt(params.userId)
    ) {
      getKeluarga(true, params.userId);
    } else {
      getKeluarga();
    }
  }, []);

  return (
    <TableContainer component={Paper}>
      <Table className={classes.table} aria-label="customized table">
        <TableHead>
          <TableRow>
            <StyledTableCell>No</StyledTableCell>
            <StyledTableCell>No KTP</StyledTableCell>
            <StyledTableCell>Nama</StyledTableCell>
            <StyledTableCell>Tempat Lahir</StyledTableCell>
            <StyledTableCell>Tanggal Lahir</StyledTableCell>
            <StyledTableCell>Agama</StyledTableCell>
            <StyledTableCell>Hubungan</StyledTableCell>
            <StyledTableCell>Pendidikan Terakhir</StyledTableCell>
            <StyledTableCell>Pekerjaan</StyledTableCell>
            <StyledTableCell>Instansi</StyledTableCell>
            {auth.user.id === parseInt(params.userId) || hcis ? (
              <StyledTableCell>Action</StyledTableCell>
            ) : null}
          </TableRow>
        </TableHead>
        <TableBody>
          {detailEmployee.keluarga.length === 0 && (
            <StyledTableRow>
              <StyledTableCell
                align="center"
                colSpan={
                  auth.user.id === parseInt(params.userId) || hcis ? 12 : 11
                }
              >
                Data Kosong
              </StyledTableCell>
            </StyledTableRow>
          )}
          {detailEmployee.keluarga.map((row, index) => (
            <StyledTableRow key={row.id}>
              <StyledTableCell>{index + 1}</StyledTableCell>
              <StyledTableCell>{row.id_number}</StyledTableCell>
              <StyledTableCell>{capitalize(row.name)}</StyledTableCell>
              <StyledTableCell>{row.place_of_birth}</StyledTableCell>
              <StyledTableCell>{row.date_of_birth}</StyledTableCell>
              <StyledTableCell>{capitalize(row.religion)}</StyledTableCell>
              <StyledTableCell>{capitalize(row.relation)}</StyledTableCell>
              <StyledTableCell>{row.educational_stage}</StyledTableCell>
              <StyledTableCell>{capitalize(row.job_name)}</StyledTableCell>
              <StyledTableCell>{capitalize(row.company_name)}</StyledTableCell>
              {auth.user.id === parseInt(params.userId) || hcis ? (
                <StyledTableCell>
                  <Tooltip title="Edit Data">
                    <IconButton
                      className={classes.iconAction}
                      color="primary"
                      onClick={() =>
                        setDialog({ open: true, edit: true, value: row })
                      }
                    >
                      <EditIcon />
                    </IconButton>
                  </Tooltip>
                </StyledTableCell>
              ) : null}
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

const mapStateToProps = (state) => {
  return {
    detailEmployee: state.detailEmployee,
    auth: state.auth,
  };
};

export default connect(mapStateToProps, { getKeluarga })(TableKeluarga);
